export const Sparkle = ({ className = "w-4 h-4" }) => {
    return (
        <svg 
            viewBox="0 0 24 24" 
            className={`${className} animate-sparkle`}
            fill="currentColor"
        >
            <path d="M12 0L14.59 9.41L24 12L14.59 14.59L12 24L9.41 14.59L0 12L9.41 9.41L12 0Z" />
        </svg>
    );
};
